import React, { useState } from "react";
import QRCodeGenerator from "../qrcode/QRCodeGenerator";
import { Box, useTheme, Card, Stack, Typography, Divider, Button, Grid } from "@mui/material";
import { tokens } from "../../../theme/theme";
import { useTranslation } from "react-i18next";
import qrcode from 'qrcode';

const LabelBundleDetails = ({ qrCodeValue, ProductDetail, company_id, packingWeight }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();

    const [headerData, setheaderData] = useState({
        logo: process.env.PUBLIC_URL + '/Assets/images/ITC_logo.png',
    });

   const handleButtonClick = async (bundle_number) => {
        let isvalid = true;

        const bundledet = ProductDetail.find(
            (detail) => detail.bundle_number === bundle_number
        );

        if (bundledet.bundle_number === '') {
            isvalid = false;
        }

        if (isvalid === true) {
            const printWindow = window.open('', '_blank');
            try {
                // Generate QR code data URL
                const qrDataUrl = await generateQRCode(bundledet.bundle_number);
                if (!qrDataUrl) {
                    console.error('Error generating QR code for value:', bundledet.bundle_number);
                }


                if (company_id === '1') {
                    // Write HTML content to the print window
                    printWindow.document.write(`
                                                <html>
                                                    <head>
                                                        <title>Printed Report</title>
                                                        <style>
                                                            body {
                                                                margin: 0;
                                                                padding: 20px;
                                                                font-family: Arial, sans-serif;
                                                                background-color: #f4f4f4;
                                                            }
                                                            .container {
                                                                display: flex;
                                                                align-items: flex-start;
                                                                justify-content: space-between;
                                                                padding: 10px;
                                                                background-color: white;
                                                                border: 1px solid #ccc;
                                                                box-sizing: border-box;
                                                                width: 100%;
                                                            }
                                                            .qr-code {
                                                                width: 150px; /* Adjust as needed */
                                                            }
                                                            .bundle-details {
                                                                flex: 1;
                                                                margin-left: 20px; /* Adjust spacing between QR code and bundle details */
                                                            }
                                                            .bundle-details h5 {
                                                                margin: 0;
                                                                font-size: 18px;
                                                                font-weight: bold;
                                                            }
                                                            .details-table {
                                                                display: grid;
                                                                grid-template-columns: 180px auto;
                                                                gap: 10px 20px;
                                                                margin-top: 10px;
                                                            }
                                                            .details-table div {
                                                                font-size: 16px;
                                                            }
                                                            .details-table .label {
                                                                font-weight: bold;
                                                            }
                                                            .bundle-details hr {
                                                                margin: 10px 0;
                                                                border: 1px solid #ccc;
                                                            }
                                                        </style>
                                                    </head>
                                                    <body>
                                                        <div class="container">
                                                            <div>
                                                                <img class="qr-code" src="${qrDataUrl}" alt="QR Code" />
                                                                <h4 >${bundledet.bundle_number || 'XXXXXX0123'}</h4>
                                                            </div>
                                                            <div class="bundle-details">
                                                                <h5>BUNDLE DETAILS</h5>
                                                                <hr/>
                                                                <div class="details-table">
                                                                    <div class="label">DATE / SHIFT </div><div>:  ${bundledet.shift_date} / ${bundledet.shift_code}</div>  
                                                                    <div class="label">QUALITY</div><div>: ${bundledet.item_code}</div>   
                                                                    <div class="label">REEL NO</div><div>: ${bundledet.cr_number || '0'}</div>  
                                                                    <div class="label">BUNDLE NO</div><div>: ${bundledet.bundle_number}</div>  
                                                                    <div class="label">BUNDLE WT (KG)</div><div>: ${bundledet.bundle_weight || 0}</div>     
                                                                    <div class="label">REAMS/BUNDLE</div><div>: ${bundledet.no_of_reams || 0}</div>                       
                                                                    <div class="label">GRAIN</div><div>: ${bundledet.grain || ''}</div>
                                                                    <div class="label">MA NO</div><div>: ${bundledet.lot_no || ''}</div>
                                                                    <div class="label">SO NO</div><div>: ${bundledet.indent_no || ''}</div>
                                                                    <div class="label">CUSTOMER</div><div>: ${bundledet.customer_name || ''}</div>
                                                                    <div class="label">SUPPLIER</div><div>: ${bundledet.supplier_name || ''}</div>
                                                                    <div class="label">GSM</div><div>: ${bundledet.gsm || ''}</div>
                                                                    <div class="label">SIZE</div><div>: ${bundledet.size || ''} </div> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </body>
                                                </html>
                                            `);
                }
                else if (company_id === '13') {

                    printWindow.document.write(`
                        <html>
                        <head>
                            <title>Label Printing</title>
                             <style>
                                    @page {
                                         size: 100mm 75mm; /* Portrait orientation */
                                         margin: 0; /* Remove margins for edge-to-edge printing */
                                    }
                                    body {
                                        margin: 0;
                                        padding: 0;
                                        font-family: Arial, sans-serif;
                                        display: flex;
                                        flex-direction: column;
                                        align-items: flex-start;
                                        justify-content: flex-start;
                                        box-sizing: border-box;
                                    }
                                    .label {
                                        width: 100mm;
                                        height: 75mm;
                                        padding: 3mm;
                                        box-sizing: border-box;
                                        
                                        display: flex;
                                        flex-direction: column;
                                        justify-content: space-between;
                                       
                                    }
                                    .label{                                       
                                        page-break-after: always; /* Ensure each label starts on a new page */                                
                                    }    
                                    .container {
                                        display: flex;
                                        align-items: center;
                                        justify-content: space-between;
                                        width: 100%;
                                        height: 35px;
                                        padding: 0; /* Remove padding from the container */
                                        box-sizing: border-box;
                                        margin-top:2mm;
                                    }
    
                                    .container1 {
                                            display: flex;
                                            align-items: center;
                                            justify-content: space-between;
                                            width: 100%;
                                            height: 2px;
                                            padding: 0;
                                            box-sizing: border-box;
                                            font-size: 2rem;
                                            font-weight: bold;
                                            
                                        }

                                        .container2 {
                                            display: flex;
                                            align-items: center;
                                            justify-content: space-between;
                                            width: 100%;
                                            height: 1px;
                                            padding: 0;
                                            box-sizing: border-box;
                                            font-size: 6rem;
                                            font-weight: bold;
                                           
                                        }
                                    .logo {
                                        max-width: 50mm; /* Ensure logo scales within a small area */
                                        height: auto;
                                        margin-left: 1mm;
                                    }
                                    .text-details {
                                        flex: 1;
                                        margin-left: 1mm;
                                        margin-top: 0.2mm;
                                        font-size: 0.4rem;
                                        font-weight: bold;
                                    }
                                    .text-details p {
                                        margin: 0;
                                        line-height: 1.1; /* Reduce line spacing for compactness */
                                        font-weight: bold;
                                        color: #01579b;
                                    }
                                    .marketed-by {
                                        text-align: center;
                                        font-size: 0.2rem;
                                        font-weight: bold;
                                        margin-top: 0.5mm; /* Reduce or remove space above */
                                        margin-left:0.5mm;
                                    }
                                    .marketed-by p {
                                        margin: 0; /* Remove margins from paragraphs */
                                        line-height: 1.1; /* Compact line spacing */
                                    }
    
                                    .marketed-by2 {
                                        text-align: left;
                                        font-size: 0.6rem;
                                        font-weight: bold;
                                        margin-top: -1mm; /* Reduce or remove space above */
                                        margin-left:1mm;
                                    }

                                    .marketed-by2 p {
                                        margin: 0; /* Remove margins from paragraphs */
                                        line-height: 0.5; /* Compact line spacing */
                                    }
                                     .marketed-by1 {
                                        text-align: center;
                                        font-size: 0.8rem;
                                        font-weight: bold;
                                        margin-top: -1mm; /* Reduce or remove space above */
                                        margin-left:1mm;
                                    }

                                      .marketed-by1 p {
                                        margin: 0; /* Remove margins from paragraphs */
                                        line-height: 0.5; /* Compact line spacing */
                                    }
                                    .logo {
                                        max-width: 10mm;
                                        height: auto;
                                    }
                                    .text-details p, .marketed-by p, .details-section .label, .details-section .value {
                                        margin: 0;
                                        font-size: 0.5rem; /* Adjust for readability */
                                        line-height: 1.2;
                                    }
                                    
                                    .details-section {
                                        display: flex;
                                        flex-wrap: wrap;
                                        gap: 2mm;
                                    }
                                    .details-section .label, .details-section .value {
                                        flex: 1 1 45%; /* Adjust for label and value alignment */
                                    }
                                </style>
                        </head>
                        <body>
                            <div class="label">
                                <div class="header-row">
                                    <div class="container">
                                        <!-- Logo Section -->
                                        <div>
                                           
                                        </div>

                                        <!-- Text Details -->
                                        <div class="text-details">
                                            
                                        </div>

                                        <div class="marketed-by">
                                          
                                        </div>
                                    </div>
                                </div>

                                 <!-- Detail header-->

                                 <div>
                                   <table border="0" style="width: 100%; border-collapse: collapse; text-align: left;">
                                    <thead>
                                        <tr style="font-size: 14px">
                                            <th style="font-weight: normal;text-align: left;">PRODUCT</th>
                                            <th style="font-weight: normal;text-align: center;">GRAIN</th>
                                            <th style="font-weight: normal;text-align: center;">GSM</th>
                                            <th style="font-weight: normal;text-align: center;">SIZE</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style="font-size: 14px;font-weight: bold;">
                                            <td >${bundledet.item_code}</td>
                                            <td style="text-align: center;">${bundledet.grain}</td>
                                            <td style="text-align: center;">${bundledet.gsm}</td>
                                            <td style="text-align: center;">${bundledet.size}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                
                                <table border="0" style="width: 100%; border-collapse: collapse; text-align: left; margin-top: 5px;">
                                    <thead>
                                        <tr style="font-size: 12px;">
                                            <th style="font-weight: normal;text-align: left;">NO OF REAM</th>
                                            <th style="font-weight: normal;text-align: center;">GROSS WEIGHT (KG)</th>
                                            <th style="font-weight: normal;text-align: center;">NET WEIGHT (KG)</th>
                                            <th style="font-weight: normal;text-align: center;">REAM WEIGHT (KG)</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    <tr style="font-size: 14px;font-weight: bold;text-align: center;">
                                        <td style="width: 30%;">${bundledet.no_of_reams}</td>                                     

                                        <td style="width: 30%;">
                                        ${((bundledet.bundle_weight || 0) + (packingWeight || 0)).toFixed(1)}
                                        </td>
                                        <td style="width: 30%;">
                                        ${(bundledet.bundle_weight || 0).toFixed(1)}
                                        </td>
                                        <td style="width: 20%;">
                                        ${(bundledet.ream_weight || 0).toFixed(1)}
                                        </td>

                                    </tr>
                                
                                    </tbody>
                                </table>
                                
                                <table border="0" style="width: 100%; border-collapse: collapse; text-align: left; margin-top: 5px;">
                                    <thead>
                                        <tr style="font-size: 12px;">
                                            <th style="font-weight: normal;text-align: left;">BUNDLE NUMBER</th>
                                            <th style="font-weight: normal;text-align: center;">LOT NO.</th>
                                            <th style="font-weight: normal;text-align: center;">PRODUCTION DATE</th>
                                            <th style="font-weight: normal;text-align: center;">COUNTRY ORIGIN</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr style="font-size: 14px;font-weight: bold;">
                                            <td>${bundledet.bundle_number}</td>
                                            <td >${bundledet.pr_number}</td>
                                            <td style="text-align: center;">${bundledet.shift_date}</td>
                                            <td style="font-size: 12px;">MADE IN INDIA</td>
                                        </tr>
                                    </tbody>
                                </table>
                                </div>


                              
                            </div>
                            <!-- Duplicate label blocks for additional labels -->
                        </body>
                        </html>
                    `);



                }


                // Close and print the window
                // printWindow.document.close();
                // printWindow.print();
            } catch (error) {
                console.error('Error handling button click:', error);
            }
        }
    };






    

    const handleButtonClickNew = async (bundle_number) => {
        let isvalid = true;

        const bundledet = ProductDetail.find(
            (detail) => detail.bundle_number === bundle_number
        );

        if (bundledet.bundle_number === '') {
            isvalid = false;
        }

        if (isvalid === true) {
            const printWindow = window.open('', '_blank');
            try {
                // Generate QR code data URL
                const qrDataUrl = await generateQRCode(bundledet.bundle_number);
                if (!qrDataUrl) {
                    console.error('Error generating QR code for value:', bundledet.bundle_number);
                }


                if (company_id === '1') {
                    // Write HTML content to the print window
                    printWindow.document.write(`
                                                <html>
                                                    <head>
                                                        <title>Printed Report</title>
                                                        <style>
                                                            body {
                                                                margin: 0;
                                                                padding: 20px;
                                                                font-family: Arial, sans-serif;
                                                                background-color: #f4f4f4;
                                                            }
                                                            .container {
                                                                display: flex;
                                                                align-items: flex-start;
                                                                justify-content: space-between;
                                                                padding: 10px;
                                                                background-color: white;
                                                                border: 1px solid #ccc;
                                                                box-sizing: border-box;
                                                                width: 100%;
                                                            }
                                                            .qr-code {
                                                                width: 150px; /* Adjust as needed */
                                                            }
                                                            .bundle-details {
                                                                flex: 1;
                                                                margin-left: 20px; /* Adjust spacing between QR code and bundle details */
                                                            }
                                                            .bundle-details h5 {
                                                                margin: 0;
                                                                font-size: 18px;
                                                                font-weight: bold;
                                                            }
                                                            .details-table {
                                                                display: grid;
                                                                grid-template-columns: 180px auto;
                                                                gap: 10px 20px;
                                                                margin-top: 10px;
                                                            }
                                                            .details-table div {
                                                                font-size: 16px;
                                                            }
                                                            .details-table .label {
                                                                font-weight: bold;
                                                            }
                                                            .bundle-details hr {
                                                                margin: 10px 0;
                                                                border: 1px solid #ccc;
                                                            }
                                                        </style>
                                                    </head>
                                                    <body>
                                                        <div class="container">
                                                            <div>
                                                                <img class="qr-code" src="${qrDataUrl}" alt="QR Code" />
                                                                <h4 >${bundledet.bundle_number || 'XXXXXX0123'}</h4>
                                                            </div>
                                                            <div class="bundle-details">
                                                                <h5>BUNDLE DETAILS</h5>
                                                                <hr/>
                                                                <div class="details-table">
                                                                    <div class="label">DATE / SHIFT </div><div>:  ${bundledet.shift_date} / ${bundledet.shift_code}</div>  
                                                                    <div class="label">QUALITY</div><div>: ${bundledet.item_code}</div>   
                                                                    <div class="label">REEL NO</div><div>: ${bundledet.cr_number || '0'}</div>  
                                                                    <div class="label">BUNDLE NO</div><div>: ${bundledet.bundle_number}</div>  
                                                                    <div class="label">BUNDLE WT (KG)</div><div>: ${bundledet.bundle_weight || 0}</div>     
                                                                    <div class="label">REAMS/BUNDLE</div><div>: ${bundledet.no_of_reams || 0}</div>                       
                                                                    <div class="label">GRAIN</div><div>: ${bundledet.grain || ''}</div>
                                                                    <div class="label">MA NO</div><div>: ${bundledet.lot_no || ''}</div>
                                                                    <div class="label">SO NO</div><div>: ${bundledet.indent_no || ''}</div>
                                                                    <div class="label">CUSTOMER</div><div>: ${bundledet.customer_name || ''}</div>
                                                                    <div class="label">SUPPLIER</div><div>: ${bundledet.supplier_name || ''}</div>
                                                                    <div class="label">GSM</div><div>: ${bundledet.gsm || ''}</div>
                                                                    <div class="label">SIZE</div><div>: ${bundledet.size || ''} </div> 
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </body>
                                                </html>
                                            `);
                }
                else if (company_id === '13') {

                    printWindow.document.write(`
                        <html>
                        <head>
                            <title>Label Printing</title>
                            <style>
                                @page {
                                    size: 100mm 75mm;
                                    margin: 0;
                                }
                                body {
                                    margin: 0;
                                    padding: 0;
                                    font-family: Arial, sans-serif;
                                    box-sizing: border-box;
                                }
                                .label {
                                    width: 100mm;
                                    height: 75mm;
                                    padding: 2mm;
                                    box-sizing: border-box;
                                    display: flex;
                                    flex-direction: column;
                                    page-break-after: always;
                                    overflow: hidden;
                                }
                                .header-space {
                                    height: 15mm;
                                    min-height: 15mm;
                                    flex-shrink: 0;
                                }
                                .content {
                                    flex: 1;
                                    display: flex;
                                    flex-direction: column;
                                    overflow: hidden;
                                }
                                .table-section {
                                    flex: 1;
                                    display: flex;
                                    flex-direction: column;
                                }
                                .table-section table {
                                    width: 100%;
                                    height: 100%;
                                    border-collapse: collapse;
                                    table-layout: fixed;
                                }
                                .table-section + .table-section table th,
                                .table-section + .table-section table td {
                                    border-top: none;
                                }
                                th, td {
                                    border: 1px solid #000;
                                    padding: 2px 4px;
                                    vertical-align: middle;
                                }
                                th {
                                    font-size: 11px;
                                    font-weight: normal;
                                }
                                td {
                                    font-size: 15px;
                                    font-weight: bold;
                                }
                                .qr-cell img {
                                    width: 15mm;
                                    height: 15mm;
                                    display: block;
                                    margin: 0 auto;
                                }
                            </style>
                        </head>
                        <body>
                            <div class="label">

                                <!-- Top space reserved for logo -->
                                <div class="header-space"></div>

                                <div class="content">

                                    <!-- Row 1: PRODUCT | GRAIN | GSM | SIZE -->
                                    <div class="table-section">
                                        <table>
                                            <thead>
                                                <tr>
                                                    <th style="text-align: left; width: 40%;">PRODUCT</th>
                                                    <th style="text-align: center; width: 20%;">GRAIN</th>
                                                    <th style="text-align: center; width: 15%;">GSM</th>
                                                    <th style="text-align: center; width: 25%;">SIZE</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td style="text-align: left;">${bundledet.item_code}</td>
                                                    <td style="text-align: center;">${bundledet.grain}</td>
                                                    <td style="text-align: center;">${bundledet.gsm}</td>
                                                    <td style="text-align: center;">${bundledet.size}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <!-- Row 2: NO OF REAM | GROSS WEIGHT | NET WEIGHT | REAM WEIGHT | PRODUCTION DATE -->
                                    <div class="table-section">
                                        <table>
                                            <thead>
                                                <tr style="text-align: center;">
                                                    <th style="width: 18%;">NO OF<br>REAM</th>
                                                    <th style="width: 20%;">GROSS<br>WEIGHT<br>(KG)</th>
                                                    <th style="width: 20%;">NET<br>WEIGHT<br>(KG)</th>
                                                    <th style="width: 20%;">REAM<br>WEIGHT<br>(KG)</th>
                                                    <th style="width: 22%;">PRODUCTION<br>DATE</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr style="text-align: center;">
                                                    <td>${bundledet.no_of_reams}</td>
                                                    <td>${((bundledet.bundle_weight || 0) + (packingWeight || 0)).toFixed(1)}</td>
                                                    <td>${(bundledet.bundle_weight || 0).toFixed(1)}</td>
                                                    <td>${(bundledet.ream_weight || 0).toFixed(1)}</td>
                                                    <td>${bundledet.shift_date}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <!-- Row 3: BUNDLE NO | QR CODE | LOT NO | COUNTRY ORIGIN -->
                                    <div class="table-section" style="flex:1.5">
                                        <table>
                                            <thead>
                                                <tr style="text-align: center;">
                                                    <th style="text-align: left; width: 30%;">BUNDLE NO</th>
                                                    <th style="width: 18%;"></th>
                                                    <th style="width: 22%;">LOT NO</th>
                                                    <th style="width: 30%;">COUNTRY ORIGIN</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr style="text-align: center;">
                                                    <td style="text-align: left;">${bundledet.bundle_number}</td>
                                                    <td class="qr-cell"><img src="${qrDataUrl}" alt="QR Code" /></td>
                                                    <td>${bundledet.pr_number}</td>
                                                    <td>MADE IN INDIA</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>
                            </div>
                        </body>
                        </html>
                    `);



                }


                // Close and print the window
                // printWindow.document.close();
                // printWindow.print();
            } catch (error) {
                console.error('Error handling button click:', error);
            }
        }
    };




    //  <td style="width: 30%;">${bundledet.bundle_weight + packingWeight}</td>
    //                                     <td style="width: 30%;">${bundledet.bundle_weight}</td>
    //                                     <td style="width: 20%;">${bundledet.ream_weight}</td>

    const generateQRCode = async (value) => {
        try {
            const qrDataUrl = await qrcode.toDataURL(value);
            return qrDataUrl;
        } catch (error) {
            console.error('Error generating QR code:', error);
            return null;
        }
    };

    return (
        <>
            {ProductDetail.map((detail, index) => (
                <>
                    {company_id === 1 ? (<>
                        <Card sx={{ backgroundColor: "transparent", m: 2, padding: 1 }} >
                            <Box mb={1}>
                                <Typography variant="h5" textAlign="center">{t('prod_bundle.bundle_details')}</Typography>
                            </Box>
                            <Divider sx={{ marginBottom: "10px" }} />

                            <Grid container spacing={0} justifyContent="space-between" alignItems="center">
                                <Grid item xs={12} lg={8}>
                                    <Grid container spacing={0}>
                                        {/* Date and Shift */}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">{`DATE / SHIFT :`}</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={7}>
                                            <Typography variant="h7">{`${detail.shift_date || ''} / ${detail.shift_code || ''}`}</Typography>
                                        </Grid>

                                        {/* M.O No */}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">QUALITY :</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">{detail.item_code}</Typography>
                                        </Grid>

                                        {/* M.A No */}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">REEL NO :</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">{detail.cr_number}</Typography>
                                        </Grid>

                                        {/* Quantity */}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">BUNDEL NO :</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">{detail.bundle_number}</Typography>
                                        </Grid>

                                        {/* GSM */}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">BUNDLE.WT (KG) :</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={7}>
                                            <Typography variant="h7">{detail.bundle_weight}</Typography>
                                        </Grid>

                                        {/* No. Set */}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">REAMS/BUNDLE :</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">{detail.no_of_reams}</Typography>
                                        </Grid>

                                        {/* ID / OD */}
                                        {/* <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">REAM.WT (KG) :</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">{detail.ream_weight}</Typography>
                                        </Grid> */}

                                        {/* TOTAL SHEETS */}
                                        {/* <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">TOTAL SHEETS :</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">{detail.sheets_in_bundle}</Typography>
                                        </Grid> */}

                                        {/* TOTAL SHEETS */}
                                        {/* <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">SHEETS IN REAM:</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">{detail.sheets_in_reams || 0}</Typography>
                                        </Grid> */}

                                        {/* TOTAL SHEETS */}
                                        {/* <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">ORDER TYPE:</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">{detail.sheets_in_reams || 0}</Typography>
                                        </Grid> */}

                                        {/* GRAIN : */}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">GRAIN :</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">{detail.grain}</Typography>
                                        </Grid>

                                        {/* MODE OF PACKING */}
                                        {/* <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">MODE OF PACKING :</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">{detail.gsm}</Typography>
                                        </Grid> */}

                                        {/* MA NO : */}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">MA NO :</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">{detail.lot_no}</Typography>
                                        </Grid>

                                        {/* SO NO :*/}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">SO NO :</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">{detail.indent_no}</Typography>
                                        </Grid>

                                        {/* CUSTOMER :*/}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">CUSTOMER :</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">{detail.customer_name}</Typography>
                                        </Grid>

                                        {/* SUPPLIER :*/}
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">SUPPLIER :</Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={6} md={3} lg={5}>
                                            <Typography variant="h7">{detail.supplier_name}</Typography>
                                        </Grid>

                                    </Grid>
                                </Grid>

                                {/* QR Code */}
                                <Grid item xs={12} lg={4} textAlign="center">
                                    <Typography variant="h7">{detail.bundle_number}</Typography>
                                    <QRCodeGenerator value={detail.bundle_number} />
                                </Grid>
                            </Grid>





                            <Box>
                                <Typography variant="h4">GSM: {detail.gsm}</Typography>
                                <Typography variant="h4">SIZE :  {detail.size}</Typography>
                            </Box>
                            <Divider sx={{ marginTop: "5px", marginBottom: "5px" }} />
                            <Box item mt={2} xs={12} lg={12} display="flex" justifyContent="flex-end">
                                <Button size="small" sx={{ textTransform: "none" }} variant="contained" color="secondary" onClick={() => handleButtonClick(detail.bundle_number)}>Print</Button>
                            </Box>
                        </Card>
                    </>) : company_id == 2 ? (<></>) : null}
                    <Card sx={{ backgroundColor: "#f5f5f5", m: 2, padding: 1 }} >
                        <Grid container justifyContent="flex" alignItems="center">
                            <Grid item xs={12} md={4} lg={12} xl={12}>

                                <Grid container justifyContent="flex" alignItems="center">
                                    <Grid item xs={12} md={4} lg={0.1} xl={0.1}>
                                        <Box>
                                            <img
                                                src={headerData.logo}
                                                alt="Mill Logo"
                                                style={{ maxWidth: '50px', height: 'auto', objectFit: 'contain' }} // Ensuring the logo scales properly
                                            />
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} md={4} lg={5} xl={5}>
                                        <Box marginLeft={7}>
                                            <Typography variant="h4" fontWeight="bold" color="#01579b" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.8rem' } }}>
                                                PAPERBOARDS
                                            </Typography>
                                            <Typography variant="h4" fontWeight="bold" color="#01579b" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.8rem' } }}>
                                                AND
                                            </Typography>
                                            <Typography variant="h4" fontWeight="bold" color="#01579b" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.8rem' } }}>
                                                SPECIALTY
                                            </Typography>
                                            <Typography variant="h4" fontWeight="bold" color="#01579b" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.8rem' } }}>
                                                PAPERS DIVISION
                                            </Typography>
                                        </Box>
                                    </Grid>

                                    <Grid item xs={12} md={4} lg={3} xl={4}>
                                        <Box mb={0} textAlign="center">
                                            <Typography variant="subtitle1" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.6rem' } }}>Marketed By:</Typography>
                                            <Typography variant="subtitle1" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.6rem' } }}>ITC Limited</Typography>
                                            <Typography variant="subtitle1" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.6rem' } }}>106, SP Road, Secunderabad</Typography>
                                            <Typography variant="subtitle1" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.6rem' } }}>Telangaa - 500003</Typography>
                                            <Typography variant="subtitle1" fontWeight="bold" color="black" sx={{ fontSize: { xs: '0.9rem', sm: '1rem', lg: '0.6rem' } }}>Phone: 91-40-27846566-73</Typography>
                                        </Box>
                                    </Grid>


                                </Grid>


                            </Grid>

                            <Grid item xs={12} md={4} lg={12} xl={12}>
                                <Grid container justifyContent="flex" alignItems="center">
                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="h5" color="black" sx={{ fontWeight: "bold", display: "flex", justifyContent: "left", marginLeft: "0px" }}>PRODUCT</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="h5" color="black" sx={{ fontWeight: "bold", display: "flex", justifyContent: "left", marginLeft: "0px" }}>GRAIN</Typography>
                                    </Grid>

                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="h5" color="black" sx={{ fontWeight: "bold", display: "flex", justifyContent: "left", marginLeft: "0px" }}>GSM</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="h5" color="black" sx={{ fontWeight: "bold", display: "flex", justifyContent: "left", marginLeft: "0px" }}>SIZE</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} md={4} lg={12} xl={12}>
                                <Grid container justifyContent="flex" alignItems="center">
                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="h5" color="black" sx={{ fontWeight: "bold", display: "flex", justifyContent: "left", marginLeft: "0px" }}>{detail.item_code}</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="h5" color="black" sx={{ fontWeight: "bold", display: "flex", justifyContent: "left", marginLeft: "0px" }}>{detail.grain}</Typography>
                                    </Grid>

                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="h5" color="black" sx={{ fontWeight: "bold", display: "flex", justifyContent: "left", marginLeft: "0px" }}>{detail.gsm}</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="h5" color="black" sx={{ fontWeight: "bold", display: "flex", justifyContent: "left", marginLeft: "0px" }}>{detail.size}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} md={4} lg={12} xl={12}>
                                <Grid container justifyContent="flex" alignItems="center">
                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="subtitle2" color="black" sx={{ fontWeight: "bold" }}>NO OF REAM</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="subtitle2" color="black" sx={{ fontWeight: "bold" }}>GROSS WEIGHT (KG)</Typography>
                                    </Grid>

                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="subtitle2" color="black" sx={{ fontWeight: "bold" }}>NET WEIGHT (KG)</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="subtitle2" color="black" sx={{ fontWeight: "bold" }}>REAM WEIGHT (KG)</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} md={4} lg={12} xl={12}>
                                <Grid container justifyContent="flex" alignItems="center">
                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="h4" color="black" sx={{ fontWeight: "bold", display: "flex", justifyContent: "left", marginLeft: "20px" }}>{detail.no_of_reams}</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="h7" color="black" sx={{ fontWeight: "bold", display: "flex", justifyContent: "left", marginLeft: "20px" }}>{(detail.bundle_weight + packingWeight).toFixed(1)}</Typography>
                                    </Grid>

                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="h7" color="black" sx={{ fontWeight: "bold", display: "flex", justifyContent: "left", marginLeft: "20px" }}>{(detail.bundle_weight).toFixed(1)}</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="h7" color="black" sx={{ fontWeight: "bold", display: "flex", justifyContent: "left", marginLeft: "20px" }}>{(detail.ream_weight).toFixed(1)}</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} md={4} lg={12} xl={12}>
                                <Grid container justifyContent="flex" alignItems="center">
                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="subtitle2" color="black" sx={{ fontWeight: "bold" }}>BUNDLE NUMBER</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="subtitle2" color="black" sx={{ fontWeight: "bold", marginLeft: "20px" }}>LOT NO.</Typography>
                                    </Grid>

                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="subtitle2" color="black" sx={{ fontWeight: "bold" }}>PRODUCTION DATE</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="h5" color="black" sx={{ fontWeight: "bold" }}>MADE IN INDIA</Typography>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} md={4} lg={12} xl={12}>
                                <Grid container justifyContent="flex" alignItems="center">
                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="h5" color="black" sx={{ fontWeight: "bold", display: "flex", justifyContent: "left", marginLeft: "0px" }}>{detail.bundle_number}</Typography>
                                    </Grid>
                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="h5" color="black" sx={{ fontWeight: "bold", display: "flex", justifyContent: "left", marginLeft: "20px" }}>{detail.pr_number}</Typography>
                                    </Grid>

                                    <Grid item xs={12} md={4} lg={3} xl={3}>
                                        <Typography variant="h5" color="black" sx={{ fontWeight: "bold", display: "flex", justifyContent: "left", marginLeft: "20px" }}>{detail.shift_date}</Typography>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </Grid>


                        <Divider sx={{ borderColor: "black", marginTop: "5px", marginBottom: "5px" }} />

                        {/* {hasPermission(userPermissions, "Ream Punching", "Print") && ( */}
                        <Box item mt={2} xs={12} lg={12} display="flex" justifyContent="flex-end">
                            <Button size="small" sx={{ textTransform: "none",mr: 1 }} variant="contained" color="secondary" onClick={() => handleButtonClick(detail.bundle_number)}>Print</Button>

                            <Button size="small" sx={{ textTransform: "none" }} variant="contained" color="secondary" onClick={() => handleButtonClickNew(detail.bundle_number)}>Print New QR</Button>
                        </Box>


                        {/* )} */}

                    </Card>
                </>
            ))}
        </>
    );

}
export default LabelBundleDetails;